/*
 * HomePage
 */

import React from 'react';

// Others
import { Switch, Route, useRouteMatch } from 'react-router-dom';

// Components & Others
import NotFound from '../../NotFoundPage';
import VinculatedList from '../../../components/Models/Vinculated/VinculatedList';
import VinculatedRejectedList from '../../../components/Models/Vinculated/VinculatedRejectedList';
import VinculatedValidatedList from '../../../components/Models/Vinculated/VinculatedValidatedList';

function VinculatedPage() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path} component={VinculatedList} />
      <Route
        exact
        path={`${path}/desaprobados`}
        component={VinculatedRejectedList}
      />
      <Route
        exact
        path={`${path}/aprobados`}
        component={VinculatedValidatedList}
      />
      <Route exact path={path} component={NotFound} />
    </Switch>
  );
}

VinculatedPage.propTypes = {};

export default VinculatedPage;
